import React, { useCallback, useEffect, useReducer, useState } from "react";
import { Form } from "semantic-ui-react";
import RuvixxForm from "components/RuvixxForm";

import "styles/forms.scss";

import revOppsConstants from "constants/RevenueOpportunity";
import { upperFirst } from "helpers/string";
import RecipientService from "services/Recipient";

const formReducer = (s, a) => ({ ...s, ...a });
const initializer = model => {
  return {
    id: model?.id,
    name: "",
    types: [],
    enabled: true,
  };
};

function RecipientForm(props) {
  const [formData, setFormData] = useReducer(
    formReducer,
    props.model,
    initializer
  );
  const [recipientTypeOptions, setRecipientTypeOptions] = useState([]);
  const [error, setError] = useState(null);

  const fetchModel = useCallback(async () => {
    if (!formData.id) {
      return;
    }
    const model = await RecipientService.get(formData.id);
    setFormData({
      ...formData,
      id: model.id,
      name: model.name,
      types: model.types,
      enabled: model.enabled,
    });
  }, []);

  useEffect(() => {
    prepareRecipientTypeOptions();
  }, []);

  useEffect(() => {
    if (formData.id) {
      fetchModel();
    }
  }, [formData.id]);

  const handleChange = (_, data) => {
    const { name, type } = data;
    if (!name) {
      return;
    }
    const value = type === "checkbox" ? data.checked : data.value;
    const formDataCopy = { ...formData };
    formDataCopy[name] = value;
    setFormData(formDataCopy);
  };

  const prepareRecipientTypeOptions = async () => {
    const options = Object.values(revOppsConstants.recipientType).map(
      (option, index) => ({
        id: index,
        text: upperFirst(option),
        value: option,
      })
    );
    setRecipientTypeOptions(options);
  };

  const handleSubmit = async () => {
    const { id, name, types, enabled } = formData;
    const data = {
      name,
      types,
      enabled,
    };

    try {
      if (id) {
        await RecipientService.update(id, data);
      } else {
        await RecipientService.create(data);
      }
    } catch ({
      response: {
        data: { message },
      },
    }) {
      setError(message);
      throw new Error(message);
    }
  };

  return (
    <RuvixxForm
      ready={!!formData.name}
      onSubmit={handleSubmit}
      onSuccess={props.onSuccess}
      error={error?.error}
      errorMessage={error?.errorMessage}
      errorTitle={error?.errorTitle}
    >
      <Form.Input
        required
        autoFocus
        label="Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
      />
      <Form.Select
        label="Choose Recipient Type"
        required
        clearable
        name="types"
        className="fillSpace"
        multiple
        search
        selection
        onChange={handleChange}
        options={recipientTypeOptions}
        value={formData.types}
      />
      <Form.Checkbox
        toggle
        name="enabled"
        checked={formData.enabled}
        onChange={handleChange}
        label="Enabled"
      />
    </RuvixxForm>
  );
}

export default RecipientForm;
